import request from "../axios";
import { buildFeedbackPayload, buildQualityQuery, QualityQuery, QualityQueue } from "../utils/mobileQuality";

export interface MobileQualityDashboard {
  date: string;
  capturedCount: number;
  evaluatedCount: number;
  qualifiedCount: number;
  unqualifiedCount: number;
  captureIssueCount: number;
  pendingReviewCount: number;
  qualifiedRate: number;
}

export interface MobileQualityRecord {
  id: string;
  capturedAt: string;
  storeId: string;
  storeName?: string;
  dishId?: string;
  dishName?: string;
  captureImageUrl?: string;
  qualityResult?: "QUALIFIED" | "UNQUALIFIED";
  captureStatus: "VALID" | "INVALID_CAPTURE";
  aiReason?: string;
  temperatureCelsius?: number;
  aiJudgeFeedback?: 0 | 1 | null;
  aiJudgeFeedbackNote?: string;
  aiJudgeFeedbackAt?: string;
  standardImageUrl?: string;
}

export interface PageResult<T> {
  records: T[];
  total: number;
  current: number;
  size: number;
  pages: number;
}

export async function getQualityDashboard(params: {
  date: string;
  storeId?: string | number;
  dishId?: string | number;
}): Promise<MobileQualityDashboard> {
  const { data } = await request.get("/mobile/quality/dashboard", params);
  return data;
}

export async function getQualityRecords(query: QualityQuery): Promise<PageResult<MobileQualityRecord>> {
  const { data } = await request.get("/mobile/quality/records", buildQualityQuery(query));
  return data;
}

export async function getQualityRecord(recordId: string): Promise<MobileQualityRecord> {
  const { data } = await request.get(`/mobile/quality/records/${recordId}`);
  return data;
}

export async function submitQualityFeedback(recordId: string, agreed: boolean, note?: string | null) {
  const { data } = await request.post(
    `/mobile/quality/records/${recordId}/feedback`,
    buildFeedbackPayload(agreed, note)
  );
  return data as MobileQualityRecord;
}

export type { QualityQueue };
